<template>
  <Modal>
    <Modal.Title>Cancel upload</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        Are you sure you want to cancel uploading
        <span class="font-medium">{{ upload.fileName }}</span
        >?
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :size="isMobile ? 'lg' : 'md'" @click="close()">
        No, keep uploading
      </Button>
      <Button
        variant="danger"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleConfirm"
      >
        Yes, cancel upload
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import { useDevice } from '@/shared/composables/useDevice'
import { useUploadStore, type Upload } from '@/features/upload/store'
import { ErrorCodes } from '@/shared/graphql/legacy/generated'
import { analytics } from '@/shared/services/analytics'

const props = defineProps<{ upload: Upload }>()

const { close } = useModal()
const { isMobile } = useDevice()
const uploadStore = useUploadStore()

const handleConfirm = () => {
  props.upload.abortController.abort()

  uploadStore.setUploadError(props.upload._id, {
    error: ErrorCodes.UploadError,
    canceled: true,
  })

  analytics.track('copyright_upload_cancelled', {
    ...(props.upload.id ? { id: props.upload.id } : {}),
    fileName: props.upload.fileName,
    source: 'web',
    size: props.upload.size,
  })

  close()
}
</script>
